import * as React from "react";
import { Link } from "react-ui";

import { errorsFallback, KREC_ERROR_CHECK } from "../../../../../Engine/Core/ErrorManager/ErrorManager";
import { useMetrics } from "../../../../Internals/Metrics/MetricsProviderContext";
import { VIEW_FILE_WARNING } from "../../../../metricsAction";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { FileError } from "../FileError";

import { Root } from "./ViewFileWarning.styles";

interface Props {
    warning: FileError | undefined;
    path: AbsoluteModelPath;
    onClickRequirements: () => void;
}

export function ViewFileWarning(props: Props): JSX.Element {
    const track = useMetrics();

    React.useEffect(() => {
        track(VIEW_FILE_WARNING, {
            path: props.path.toLegacyPath(),
            warning: typeof props.warning === "object" ? props.warning.code : props.warning,
        });
    }, []);

    const renderWarning = (warning: FileError | undefined): JSX.Element | string | undefined => {
        if (typeof warning !== "object") {
            return warning;
        } else if (warning.code === KREC_ERROR_CHECK) {
            return (
                <span>
                    Не удалось проверить документ на соответствие{" "}
                    <Link onClick={props.onClickRequirements}>{"требованиям ФНС"}</Link>. Проверьте вручную или
                    загрузите еще раз в течение часа.
                </span>
            );
        } else {
            return errorsFallback[warning.code] ?? "";
        }
    };

    return <Root>{renderWarning(props.warning)}</Root>;
}
